import React from 'react';
import ReactSelect from 'react-select';

class Select extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };

    // Bindings
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    const classNames = ['c-select'];
    const blockClass = this.state.open ?
      'block -up' :
      'block';
    if (this.props.color) classNames.push(`-${this.props.color}`);
    if (this.props.classOpts) classNames.push(this.props.classOpts);
    if (this.props.multi) classNames.push('Select-multi-wrapper');
    return (
      <div className={classNames.join(' ')}>
        {this.props.label &&
          <span className="label">{this.props.label}</span>
        }
        {this.props.children &&
          <div className="wrapper">
            <div className={blockClass}>
              <div className="content">
                {this.props.children}
              </div>
              <ReactSelect
                {...this.props}
                onOpen={this.handleOpen}
                onClose={this.handleClose}
              />
            </div>
          </div>
        }
        {!this.props.children &&
          <ReactSelect {...this.props} />
        }
          {this.props.subscript &&
            <span className="label subscript">{this.props.subscript}</span>}
      </div>
    );
  }
}

Select.propTypes = {
  label: React.PropTypes.string,
  subscript: React.PropTypes.string,
  color: React.PropTypes.string,
  inline: React.PropTypes.bool,
  multi: React.PropTypes.bool,
  value: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array
  ]).isRequired,
  options: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
  children: React.PropTypes.any,
  classOpts: React.PropTypes.string
};

export default Select;



// WEBPACK FOOTER //
// ./app/components/common/Select.jsx